module.exports = __webpack_public_path__ + "img/halalit_bereshit_yes.c6dd5209.png";